// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"dc5d368f","54":"68b8261e","125":"16da52a4"}[chunkId] + ".chunk.css";
};